// LICENSE : MIT
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var assert = require("assert");
var almin_1 = require("almin");
var ReduceStore = (function (_super) {
    __extends(ReduceStore, _super);
    function ReduceStore() {
        var _this = _super.call(this) || this;
        /**
         * @type {ReduceState}
         **/
        _this.state = null;
        // Automatically handling onDispatch
        _this.onDispatch(_this._onDispatch.bind(_this));
        return _this;
    }
    /**
     * set `newState` to this `store.state`.
     * If `newState` is the same with `tis.state`, don't set.
     * @param {ReduceState} newState
     */
    ReduceStore.prototype.setState = function (newState) {
        if (process.env.NODE_ENV !== "production") {
            assert(this.state !== null, "this.state is null, should be set to this.state in constructor.");
            assert(newState instanceof this.state.constructor, "newState should be instanceof exist this.state.constructor.\nnewState: " + newState + "\nthis.state.constructor: " + this.state.constructor + "\n");
        }
        if (this.state.equals(newState)) {
            return;
        }
        this.state = newState;
        this.emitChange();
    };
    /**
     * Call `State#reduce` and setState
     * @param {Payload} payload
     * @private
     */
    ReduceStore.prototype._onDispatch = function (payload) {
        if (process.env.NODE_ENV !== "production") {
            assert(this.state !== null, "this.state is null, should be set to this.state in constructor.");
            assert(payload !== undefined, "payload is undefined: " + payload);
        }
        this.setState(this.state.reduce(payload));
    };
    return ReduceStore;
}(almin_1.Store));
exports.ReduceStore = ReduceStore;
//# sourceMappingURL=ReduceStore.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-reduce-store/lib/ReduceStore.js
// module id = 233
// module chunks = 0